import { LoadingButton } from '@mui/lab';
import { Box, Button, Modal, Stack, Typography } from '@mui/material';
import React, { useState } from 'react'
import Axios from '../../../../../axios/Axios';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../redux/features/appSlice';

function UnAssignSpoc(props) {

  const dispatch = useDispatch();
  const [ openUnassignSpocModal, setOpenUnassignSpocModal ] = useState(false);
  const [ loading, setLoading ] = useState(false);

  //Put Request : For un-assigning spoc
  const unAssignSpocToTeacher = async () => {
    try{
        setLoading(true);

        const response = await Axios("put", `teacher/unassign/spoc/${props.teacherId}`, true, { note_created_by: sessionStorage.getItem("user_id") });

        if(response.status === 200 || 201){
            setLoading(false);
            // window.location.reload();
            props.onCloseCallback()
            dispatch(
                showSnackbar({
                    message: response.data,
                    severity: "success"
                })
            )
        }
    }catch(error){
        setLoading(false);
        dispatch(
            showSnackbar({
                message: "Something went wrong while un-assigning Spoc",
                severity: "error"
            })
        )
    }
  }

  return (
    <>
    <Box variant='p'
        onClick={() => {
            setOpenUnassignSpocModal(true);
        }}
    >
        Un-assign SPOC
    </Box>
    <Modal
        open={openUnassignSpocModal}
        onClose={() => setOpenUnassignSpocModal(false)}
    >
        <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            height: "auto",
            width: "auto",
            bgcolor: 'background.paper',
            borderRadius: "5px",
            boxShadow: 24,
            p: 4,
        }}>
            <Typography variant="h5" component="h1">
                Un-assign SPOC to {props.teacherName}
            </Typography>
            <Box>
                <Typography>
                    Do you really want to un-assign this teacher from Spoc?
                </Typography>
            </Box>
            
            <Stack mt={5} spacing={4} direction="row">
                <Button 
                    color='inherit' 
                    variant="contained" 
                    onClick={() => {
                        setOpenUnassignSpocModal(false);
                        // setRowData([]);
                    }}
                >
                    Cancel
                </Button>
                <LoadingButton
                    loading={loading} 
                    variant="contained" 
                    onClick={() => unAssignSpocToTeacher()}
                >
                    Yes
                </LoadingButton>
            </Stack>
        </Box>
    </Modal>
    </>
  )
}

export default UnAssignSpoc